// Which upstream drums a phase is fed by: one, or one of each.
//
// Most phases run off a single drum — a sheath sits on one rope, an armour on
// one interior sheath — so picking the upstream means picking ONE execution.
// Three phases are different: a rope, a pre-stranding and a conductor isolation
// are all fed by several drums at once, and their upstream selection is a list.
//
// And then there is the flat cable. MYYUP has no rope phase at all: its cores
// are laid side by side rather than stranded, so the exterior sheath is
// extruded straight over the bare insulated conductors and one sheath metre
// eats one metre of EVERY colour — exactly like a rope, and unlike every other
// sheath in the factory.
//
// The wizard already knew this in the part that DRAWS the upstream picker
// (`flatSheathColors` decided the layout and the per-colour lengths). The part
// that PRE-SELECTS after "plan next phase" did not: it kept a flat list of
// three phase names, `exterior_sheat` was not among them, and so a MYYUP run
// was handed `matched[0]` — a single execution object where the flat-sheath
// view requires an array. `Array.isArray` said no, and the panel rendered with
// nothing selected at all. Selecting drums for a CYYF preselected them; doing
// the same for a MYYUP looked like the button had done nothing.
//
// So the rule lives here, once, and both sides ask it.

/** Phases fed by several drums at once rather than one. */
export const MULTI_SELECT_PHASES = ['rope', 'pre_stranding', 'conductor_isolation'];

/**
 * The conductor colours a flat-cable sheath must be fed with.
 *
 * @returns the colours, or null when this is a normal sheath sitting on a
 *          rope / interior sheath / armour drum — every other product keeps the
 *          single-drum behaviour untouched.
 */
export const flatSheathColors = (phase, product) => {
  if (phase?.name !== 'exterior_sheat') return null;
  // The distinguishing fact, and the only reliable one: a normal exterior
  // sheath depends on rope, interior_sheat or armouring. Only a flat cable's
  // depends straight on the insulated conductors.
  if (phase?.dependsOn !== 'conductor_isolation') return null;

  const iso = product?.phases?.find(p => p.name === 'conductor_isolation');
  const colors = [
    ...new Set((iso?.conductors || []).map(c => c?.isolation?.color).filter(Boolean))
  ];

  return colors.length > 1 ? colors : null;
};

export const isFlatSheathPhase = (phase, product) => !!flatSheathColors(phase, product);

/**
 * Does this phase take a LIST of upstream drums, or a single one?
 *
 * Used both when the picker is drawn and when "plan next phase" pre-selects the
 * drums the user ticked. Those two disagreeing is what the flat cable ran into.
 */
export const isMultiUpstreamPhase = (phaseName, phase, product) =>
  MULTI_SELECT_PHASES.includes(phaseName) || isFlatSheathPhase(phase, product);
